var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUser2Px = function SvgUser2Px(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 11.375V10.2917C10.8334 9.71703 10.6051 9.16593 10.1988 8.7596C9.79248 8.35327 9.24138 8.125 8.66675 8.125H4.33341C3.75878 8.125 3.20768 8.35327 2.80135 8.7596C2.39502 9.16593 2.16675 9.71703 2.16675 10.2917V11.375",
    stroke: "#6280DA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49992 5.95833C7.69654 5.95833 8.66658 4.98828 8.66658 3.79167C8.66658 2.59505 7.69654 1.625 6.49992 1.625C5.3033 1.625 4.33325 2.59505 4.33325 3.79167C4.33325 4.98828 5.3033 5.95833 6.49992 5.95833Z",
    stroke: "#6280DA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser2Px, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user2px.cb7f0901.svg";
export { ForwardRef as ReactComponent };